"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLabeledInput = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _LabeledInputMixin = require("../../mixins/components/LabeledInputMixin");
var StyledLabeledInput = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledLabeledInput",
  componentId: "c11n-8-107-0__sc-ibpk1w-0"
})(["", ""], _LabeledInputMixin.LabeledInputMixin);
exports.StyledLabeledInput = StyledLabeledInput;